import {User} from '../../shared';
import {Campagne} from '../campagne';
import {DemandeModif} from '../blocks/demande-modif/demande-modif.model';

export class Formation {
    constructor(
        public id?: number,
        public libelle?: string,
        public libelleCourt?: string,
        public libelleGrade?: string,
        public libelleMention?: string,
        public libelleParcours?: string,
        public lc?: boolean,
        public fc?: boolean,
        public rang?: boolean,
        public affichageRang?: boolean,
        public rangAuto?: boolean,
        public surbooking?: boolean,
        public nbPlacesSurbooking?: number,
        public nbDesistementsSurbooking?: number,
        public avecPreavis?: boolean,
        public nombreReferents?: number,
        public nombreReferentsContact?: number,
        public nombreReferentsObligatoires?: number,
        public typePiece?: number,
        public mentionId?: number,
        public parcoursId?: number,
        public disciplineId?: number,
        public niveauId?: number,
        public mentionCode?: string,
        public parcoursCode?: string,
        public niveauCode?: string,
        public serviceId?: number,
        public campagneId?: number,
        public users?: User[],
        public lecteurs?: User[],
        public campagnes?: Campagne[],
        public demandeModifs?: DemandeModif[],
        public dateSuppression?: any,
        public venueConfirmable?: boolean

    ) {
        this.lc = false;
        this.rang = false;
        this.affichageRang = false;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/formation/formation.model.ts